import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const loginApi = createApi({
  reducerPath: "loginApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.NEXT_PUBLIC_BaseURL,
  }),
  tagTypes: ["login"],
  endpoints: (builder) => ({
    loginUser: builder.mutation({
      query: (input) => ({
        url: `/auth/login`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["login"],
    }),
    registerUser: builder.mutation<void, any>({
      query: (input) => ({
        url: `/auth/register`,
        method: "POST",
        body: input,
      }),
      invalidatesTags: ["login"],
    }),
    verifyEmail: builder.query<any, string>({
      query: (token) => ({
        url: `/auth/verify-email?token=${token}`,
        method: "GET",
      }),
    }),
    forgotPassword: builder.mutation<{ message: string }, { email: string }>({
      query: (input) => ({
        url: `/auth/forgot-password`,
        method: "POST",
        body: input,
      }),
    }),
    resetPassword: builder.mutation<
      { message: string },
      { token: string; new_password: string }
    >({
      query: (input) => ({
        url: `/auth/reset-password`,
        method: "POST",
        body: input,
      }),
    }),
    verifyResetToken: builder.query<{ message: string }, string>({
      query: (token) => ({
        url: `/auth/verify-reset-token?token=${token}`,
        method: "GET",
      }),
    }),

  }),
})


export const {
  useLoginUserMutation,
  useRegisterUserMutation,
  useVerifyEmailQuery,
  useForgotPasswordMutation,
  useResetPasswordMutation,
  useVerifyResetTokenQuery,
} = loginApi;
